<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="col-lg-12">
            <div class="card col-12">
                <div class="card-body">
                    <div class="d-flex justify-content-between">
                        <div>
                            <h4 class="card-title">Διαχείριση Εποπτών</h4>
                            <p class="card-title-desc">Διαχείριση μη δεντρικών ιεραρχιών</p>
                        </div>
                        <div>
                            <b-button class="btn me-2" variant="success" @click="openCreateSupervisorModal()"
                                @refreshEntity="fetchEntity">Δημιουργία
                                Νέου Επόπτη</b-button>
                        </div>
                    </div>
                    <div class="justify-content-between col-12">
                        <b-table :items="entity" :fields="tableFields" style="table-layout:fixed;">
                            <template #cell(actions)="row">
                                <div class="d-flex align-items-center">
                                    <b-button class="btn me-2" variant="primary"
                                        @click="openEditGroupModal(row.item.supervisor)" @refreshEntity="fetchEntity"><i
                                            class="mdi mdi-pencil"></i>
                                        Επεξεργασία</b-button>
                                    <b-button class="btn me-2" variant="secondary"
                                        @click="openWatchGroupModal(row.item.supervisor)"><i class="mdi mdi-eye"></i>
                                        Προβολή Μελών</b-button>
                                    <b-button class="btn me-2" variant="danger"
                                        @click="openDeleteGroupModal(row.item.supervisor)"><i
                                            class="mdi mdi-trash-can"></i></b-button>
                                </div>
                            </template>

                        </b-table>
                        <b-modal ref="editGroupModal" id="editGroupModal" centered hide-footer size="lg">
                            <EntityGroupEditModal @fetchEntity=fetchEntity :supervisorId="selectedSupervisorId"
                                :detailedEntity="detailedEntity" cardTitle="Εμφάνιση Γκρουπ"
                                description="Εμφάνιση Μελών Γκρουπ" />
                        </b-modal>
                        <b-modal ref="watchGroupModal" id="watchGroupModal" centered hide-footer size="lg">
                            <WatchGroupModal :supervisorId="supervisorId" cardTitle="Εμφάνιση Γκρουπ"
                                description="Εμφάνιση Μελών Γκρουπ" />
                        </b-modal>
                        <b-modal ref="createSupervisorModal" id="createSupervisorModal" centered hide-footer size="lg">
                            <CreateSupervisorModal @fetchEntity=fetchEntity cardTitle="Επιλογή Νέου Επόπτη" />
                        </b-modal>
                        <b-pagination v-model="currentPage" :total-rows="count" :per-page="perPage"
                            aria-controls="my-table" class="pagination pagination-rounded mb-0"></b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import session from "../../../../api/session";
import EntityGroupEditModal from "./entityGroupEditModal.vue";
import WatchGroupModal from "./watchGroupModal.vue";
import CreateSupervisorModal from "./createSupervisorModal.vue";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Διαχείριση Οργάνωσης",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
        Layout,
        PageHeader,
        EntityGroupEditModal,
        WatchGroupModal,
        CreateSupervisorModal,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const hasEntityGroups = vm.$store.getters["auth/has_entity_groups"];
            if (!hasEntityGroups) {
                next({ name: "home" });
            }
        });
    },

    data() {
        return {
            title: "Διαχειριση Γκρουπ",
            items: [
                {
                    text: "Αρχική",
                    to: { name: "home" },
                },
                {
                    text: "Διαχείριση Γκρουπ",
                    active: true,
                },
            ],

            entity: [],
            tableFields: [
                { key: "person_full_name", label: "Επόπτες" },
                {
                    key: "countMembers",
                    label: "Σύνολο Μελών",
                    tdClass: "text-center",
                    thClass: "text-center"
                },
                {
                    key: "actions",
                    label: "Ενέργειες",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ],
            count: 0,
            currentPage: 1,
            selectedSupervisorId: null,
            detailedEntity: [],
            perPage: 10,
            existingSupervisors: [],
            supervisorId: null,
        };
    },
    watch: {
        currentPage() {
            this.fetchEntity();
        },
    },
    methods: {
        async fetchEntity() {
            let paramsData = {
                page: this.currentPage,
            };
            let supervisorUrlParams = new URLSearchParams(paramsData).toString();
            await session
                .get(`api/supervisor-group/?${supervisorUrlParams}`)
                .then((resp) => {
                    this.entity = resp.data.results;
                    this.existingSupervisors = resp.data.results.map(
                        (person) => person.id
                    );
                    this.count = resp.data.count;
                });

        },
        async removeSupervisor(supervisorId) {
            await session.delete(`api/entity-group/${supervisorId}/delete`);
            this.fetchEntity();
        },
        openEditGroupModal(supervisorId) {
            this.selectedSupervisorId = supervisorId;
            this.$bvModal.show("editGroupModal");
        },
        openWatchGroupModal(supervisorId) {
            this.supervisorId = supervisorId;
            this.$bvModal.show("watchGroupModal");
        },
        openDeleteGroupModal(supervisorId) {
            console.log(supervisorId);
            Swal.fire({
                title: "Θέλετε να σβήσετε τον συγκεκριμένο επόπτη;",
                text: "Επιλέγοντας 'Ναι' θα διαγραφεί όλο το γκρουπ",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Ναι, διαγραφή",
                confirmButtonColor: "#cf5a5a", //primary
                cancelButtonText: "Ακύρωση",
                cancelButtonColor: "#485ec4", //danger
            }).then((result) => {
                if (result.isConfirmed) {
                    this.removeSupervisor(supervisorId)
                        .then(() => {
                            return Swal.fire({
                                title: "Διαγράφηκε",
                                icon: "success",
                            })
                        })
                        .catch((e) => {
                            console.log(e)
                            Swal.fire({
                                title: "Ουπς! Κάτι πήγε στραβά",
                                text: "Παρακαλώ επικοινωνήστε με τους διαχειριστές",
                                icon: "error",
                            });
                        })
                }
            });
        },
        openCreateSupervisorModal() {
            this.$bvModal.show("createSupervisorModal");
        },
    },
    mounted() {
        this.fetchEntity();
    },
};
</script>

<style>
.form-check .form-check-input {
    margin-left: 0%;
}

.form-check-input {
    width: 1.2em;
    height: 1.2em;
}
</style>